import(/* webpackMode: "eager" */ "/app/src/app/finance/phan-tich/page.tsx");
